<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <img src="img/logogardenpartsw95.jpg" class="logo" />
      <span class="devel" v-if="mthGetAPI_URL().includes('len.')">DEVEL</span>

      <CIcon
        class="c-sidebar-brand-minimized"
        name="logo"
        size="custom-size"
        :height="35"
        viewBox="0 0 110 134"
      />
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="$options.nav" />
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import navdevel from "./_navdevel";
import navprod from "./_navprod";

var nav = navprod;
if (process.env.VUE_APP_API_URL.includes("len.")) nav = navdevel;

export default {
  name: "TheSidebar",
  nav,
  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
  },
  methods: {
    mthGetAPI_URL() {
      return process.env.VUE_APP_API_URL;
    },
  },
};
</script>
<style scoped>
.logo {
  margin-bottom: 5px;
}
.devel {
  color: red;
  font: bold;
  font-size: 20pt;
  margin-left: 5px;
}
</style>